import { gql } from "@apollo/client";

export const userRefFragment = gql`
  fragment UserRef on UserRef {
    FirstName
    LastName
    MainImage {
      Id
      ContainerId
      ContainerName
    }
  }
`;
